import { ARRAY, CUSTOM } from '../constants';
import { InputField } from '../types';

export const createInitialFormikValuesFromFields = (
  fields: InputField[],
  formFields: { [key: string]: any }
): { [key: string]: any } =>
  fields.reduce(
    (initialValues, field) => ({
      ...initialValues,
      [field.name]: getFormikValues(field, formFields),
    }),
    {}
  );

const getFormikValues = (field: InputField, values: { [key: string]: any }) => {
  if (values[field.name]) {
    return values[field.name].length === 0 && field.fields && field.initialValue !== null
      ? [createInitialFormikValuesFromFields(field.fields as InputField[], values)]
      : values[field.name];
  } else {
    if (field.initialValue) {
      return field.initialValue;
    }
    if (field.type === ARRAY) {
      // Create a properly initialized array item with all required fields
      const initialItem =
        field.fields?.reduce(
          (acc, f) => ({
            ...acc,
            [f.name]: f.initialValue ?? (f.type === CUSTOM ? null : ''),
          }),
          {}
        ) ?? {};
      return [initialItem];
    }
    return '';
  }
};
